[file name]: App.vue
[file content begin]
<template>
  <div id="app">
    <!-- 顶部导航栏 - 始终显示 -->
    <header class="header">
      <nav class="navbar navbar-expand-lg">
        <div class="container">
          <a href="#" class="navbar-brand" @click.prevent="goHome">
            <span class="logo-box">
              <img
                :src="safeImageUrl(logoUrl, { preferHttps: false })"
                alt="首页"
                class="Logo"
                referrerpolicy="no-referrer"
                @error="onLogoError"
              />
            </span>
          </a>
          <button
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            class="navbar-toggler navbar-toggler-right"
            @click="toggleMobileMenu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
            </svg>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent" :class="{ show: mobileMenuOpen }">
            <ul class="navbar-nav mx-auto ml-auto">
              <li :class="['nav-item', { active: currentPage === 'home' }]">
                <div class="nav-link">
                  <a href="#" @click.prevent="switchPage('home')">首页</a>
                </div>
              </li>
              <li :class="['nav-item', { active: currentPage === 'info' }]">
                <div class="nav-link">
                  <a href="#" @click.prevent="switchPage('info')">信息</a>
                </div>
              </li>
            </ul>
            <div class="user-actions">
              <template v-if="isLoggedIn">
                <div class="user-info">
                  <span class="user-name">{{ userPhone }}</span>
                  <button class="btn logout" @click="handleLogout">退出</button>
                </div>
              </template>
              <template v-else>
                <button class="btn login" @click="switchPage('login')">登录</button>
                <button class="btn register" @click="switchPage('register')">注册</button>
              </template>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 首页 -->
      <IndexPage 
        v-if="currentPage === 'home'" 
        :safe-image-url="safeImageUrl"
        @image-error="handleImageError"
      />
      
      <!-- 信息页 -->
      <div v-else-if="currentPage === 'info'" class="info-page">
        <FlashNews />
      </div>
      
      <!-- 登录页 -->
      <LoginPage 
        v-else-if="currentPage === 'login'" 
        :logo-url="logoUrl"
        @login-success="handleLoginSuccess"
        @go-back="switchPage('home')"
        @go-register="switchPage('register')"
      />
      
      <!-- 注册页 -->
      <RegisterPage 
        v-else-if="currentPage === 'register'" 
        :logo-url="logoUrl"
        @go-back="switchPage('login')"
      />
    </main>

    <!-- 底部导航栏 - 始终显示 -->
    <div class="footer" :class="{ 'mobile-nav-hidden': currentPage === 'login' || currentPage === 'register' }">
      <div class="footer-divs container">
        <div class="footer-div">
          <!-- <div class="footer-div-top">
            <span class="logo-box">
              <img alt="logo" :src="logoUrl" class="Logo" />
            </span>
          </div> -->
        </div>
        <div class="footer-div">
          <!-- 添加备案号行 -->
          <div class="footer-div-icp">
            蜀ICP备2025177189号
          </div>
          <div class="footer-div-footer">
            Copyright © 2025 闪讯达 版权所有
          </div>
          <div class="footer-div-btn">
            <a href="#" class="a-img">
              <div class="img-ab">
                <img
                  :src="safeImageUrl(wechatUrl, { preferHttps: false })"
                  alt="微信客服二维码"
                  referrerpolicy="no-referrer"
                  @error="onQrImgError"
                />
              </div>
              <svg t="1739334462770" class="btn-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5408" width="200" height="200">
                <path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" fill="#999999" p-id="5409"></path>
              </svg>
            </a>
            <a href="#">
              <svg t="1739334395260" class="btn-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3191" width="200" height="200">
                <path d="M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z" p-id="3192" fill="#999999"></path>
              </svg>
            </a>
            <a href="#">
              <svg t="1739334424189" class="btn-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4300" width="200" height="200">
                <path d="M893.421013 263.914762c-1.982144 16.412808-9.237385 32.210609-21.676695 44.729737L581.597101 598.791715c-29.696346 29.696346-78.243015 29.696346-107.939361 0L183.510524 308.644499c-12.519128-12.519128-19.770276-28.396747-21.676695-44.729737-0.383740 3.130294-0.611937 6.259564-0.611937 9.465582l0 396.939451c0 41.983183 34.348296 76.335572 76.336596 76.335572l580.14196 0c41.980113 0 76.332503-34.352389 76.332503-76.335572L894.03295 273.380344C894.03295 270.174326 893.804752 267.045055 893.421013 263.914762L893.421013 263.914762 893.421013 263.914762z" fill="#999999" p-id="4301"></path>
              </svg>
            </a>
          </div>
        </div>
        <!-- <div class="footer-div" style="flex-wrap: wrap">
          <div style="display: flex">
            <div class="footer-div-left footer_ewm">
              <img
                :src="safeImageUrl(qqUrl, { preferHttps: false })"
                alt="QQ客服二维码"
                referrerpolicy="no-referrer"
                @error="onQrImgError"
              />
              <div>QQ客服</div>
            </div>
            <div class="footer-div-right footer_ewm">
              <img :src="wechatUrl" alt="微信客服二维码" />
              <div>微信客服</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 移动端导航栏 - 只在首页和信息页显示 -->
    <div class="flex mobile-nav" v-if="showMobileNav">
      <div class="index" :class="{ active: currentPage === 'home' }">
        <a href="#" @click.prevent="switchPage('home')">
          <div class="nameIcon icon_1"></div>
          <div>首页</div>
        </a>
      </div>
      <div class="index" :class="{ active: currentPage === 'info' }" style="border-left: 1px solid #ebebeb">
        <a href="#" @click.prevent="switchPage('info')">
          <div class="nameIcon icon_2"></div>
          <div>信息</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// 从 components 目录导入组件
import IndexPage from './components/IndexPage.vue'
import FlashNews from './components/FlashNews.vue'
import LoginPage from './components/LoginPage.vue'
import RegisterPage from './components/RegisterPage.vue'
// 图片从组件目录的images中导入
import defaultArticleImage from './components/images/article_1.png'

export default {
  name: 'App',
  components: {
    IndexPage,
    FlashNews,
    LoginPage,
    RegisterPage
  },
  data() {
    return {
      currentPage: 'home', // 当前页面：home, info, login, register
      logoUrl: '',
      qqUrl: '',
      wechatUrl: '',
      isLoggedIn: false,
      userPhone: '',
      userInfo: null,
      allowHttpDomains: ["file.tradesoeasy.xyz"],
      defaultArticleImage,
      // 自动登出相关
      inactivityTimer: null,
      logoutTimer: null,
      lastActivityTime: Date.now(),
      autoLogoutTime: 60 * 60 * 1000, // 1小时（毫秒）
      // 移动端菜单状态
      mobileMenuOpen: false
    }
  },
  computed: {
    // 移动端导航栏显示条件
    showMobileNav() {
      return this.currentPage === 'home' || this.currentPage === 'info'
    }
  },
  async created() {
    await this.loadSiteSettings()
    await this.checkLoginStatus()
    
    // 监听浏览器的前进后退按钮
    window.addEventListener('popstate', this.handlePopState)
    
    // 初始化页面状态
    const hash = window.location.hash.substring(1)
    if (hash && ['home', 'info', 'login', 'register'].includes(hash)) {
      this.currentPage = hash
    }
    
    // 初始化用户活动监听
    this.initInactivityListener()
    
    // 监听窗口大小变化，关闭移动端菜单
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState)
    window.removeEventListener('resize', this.handleResize)
    
    // 清理定时器
    this.clearTimers()
  },
  methods: {
    // 切换移动端菜单
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    
    // 处理窗口大小变化
    handleResize() {
      // 如果窗口变大到桌面尺寸，关闭移动端菜单
      if (window.innerWidth >= 992) {
        this.mobileMenuOpen = false
      }
    },
    
    async loadSiteSettings() {
      const Bmob = this.$bmob
      if (!Bmob) {
        console.warn("Bmob 未挂载到全局")
        return
      }
      
      try {
        const query = Bmob.Query("TableWebSetting")
        const res = await query.get("1bcd5683de")
        const getVal = (obj, key) => typeof obj.get === "function" ? obj.get(key) : obj[key]
        
        this.logoUrl = getVal(res, "logoUrl") || this.logoUrl
        this.qqUrl = getVal(res, "qqUrl") || this.qqUrl
        this.wechatUrl = getVal(res, "wechatUrl") || this.wechatUrl
      } catch (err) {
        console.error("获取站点设置失败:", err)
      }
    },
    
    // 切换页面
    switchPage(page) {
      this.currentPage = page
      // 更新浏览器历史记录
      history.pushState({ page }, '', `#${page}`)
      window.scrollTo(0, 0)
      
      // 关闭移动端菜单
      this.mobileMenuOpen = false
      
      // 重置活动时间
      this.resetInactivityTimer()
    },
    
    // 处理浏览器前进后退
    handlePopState(event) {
      if (event.state && event.state.page) {
        this.currentPage = event.state.page
      } else {
        const hash = window.location.hash.substring(1)
        if (hash && ['home', 'info', 'login', 'register'].includes(hash)) {
          this.currentPage = hash
        } else {
          this.currentPage = 'home'
        }
      }
      
      // 重置活动时间
      this.resetInactivityTimer()
    },
    
    // 回到首页
    goHome() {
      this.switchPage('home')
    },
    
    // 检查登录状态 - 使用Bmob.User.current()
    async checkLoginStatus() {
      try {
        const Bmob = this.$bmob
        if (!Bmob) {
          console.warn("Bmob 未挂载到全局")
          return
        }
        
        // 使用Bmob.User.current()获取当前用户信息
        const currentUser = await Bmob.User.current()
        console.log("当前用户信息:", currentUser)
        
        if (currentUser && currentUser.objectId) {
          this.isLoggedIn = true
          this.userPhone = currentUser.username || localStorage.getItem('user_phone') || ''
          this.userInfo = currentUser
          
          // 更新本地存储的用户信息
          localStorage.setItem('user_token', currentUser.sessionToken || '')
          localStorage.setItem('user_id', currentUser.objectId)
          localStorage.setItem('user_name', currentUser.username || this.userPhone)
          localStorage.setItem('user_object', JSON.stringify(currentUser))
          
          // 重置活动时间
          this.resetInactivityTimer()
        } else {
          // 如果没有用户信息，检查本地存储
          const token = localStorage.getItem("user_token")
          const phone = localStorage.getItem("user_phone")
          
          if (token && phone) {
            this.isLoggedIn = true
            this.userPhone = phone
            
            // 尝试从本地存储恢复用户信息
            const userObject = localStorage.getItem("user_object")
            if (userObject) {
              try {
                this.userInfo = JSON.parse(userObject)
              } catch (e) {
                console.error("解析用户信息失败:", e)
              }
            }
            
            // 重置活动时间
            this.resetInactivityTimer()
          } else {
            this.isLoggedIn = false
            this.userPhone = ""
            this.userInfo = null
          }
        }
      } catch (error) {
        console.error("检查登录状态失败:", error)
        // 如果检查失败，清除登录状态
        this.isLoggedIn = false
        this.userPhone = ""
        this.userInfo = null
        
        // 清除本地存储
        this.clearLocalStorage()
      }
    },
    
    // 处理登录成功
    async handleLoginSuccess() {
      // 重新检查登录状态
      await this.checkLoginStatus()
      
      // 跳转到首页
      this.switchPage('home')
      
      // 显示登录成功提示
      alert('登录成功！')
    },
    
    // 退出登录
    async handleLogout() {
      try {
        const Bmob = this.$bmob
        if (Bmob && Bmob.User) {
          // 调用Bmob的登出方法
          await Bmob.User.logout()
          console.log("Bmob登出成功")
        }
      } catch (error) {
        console.error("Bmob登出失败:", error)
      }
      
      // 清除本地存储
      this.clearLocalStorage()
      
      // 重置状态
      this.isLoggedIn = false
      this.userPhone = ""
      this.userInfo = null
      
      // 清理定时器
      this.clearTimers()
      
      // 跳转到首页
      this.switchPage('home')
      
      // 显示登出提示
      alert('已安全退出登录')
    },
    
    // 清除本地存储的用户信息
    clearLocalStorage() {
      localStorage.removeItem("user_token")
      localStorage.removeItem("user_phone")
      localStorage.removeItem("user_id")
      localStorage.removeItem("user_name")
      localStorage.removeItem("user_remember")
      localStorage.removeItem("user_object")
    },
    
    // 初始化用户活动监听
    initInactivityListener() {
      // 监听用户活动
      const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart']
      
      events.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer)
      })
      
      // 开始检查不活动状态
      this.startInactivityCheck()
    },
    
    // 重置不活动定时器
    resetInactivityTimer() {
      this.lastActivityTime = Date.now()
      
      // 清除旧的定时器
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer)
      }
      
      // 只有用户已登录时才设置自动登出
      if (this.isLoggedIn) {
        this.inactivityTimer = setTimeout(() => {
          this.checkInactivity()
        }, this.autoLogoutTime)
        
        console.log("用户活动检测重置，将在1小时后自动登出")
      }
    },
    
    // 检查不活动状态
    checkInactivity() {
      const currentTime = Date.now()
      const timeSinceLastActivity = currentTime - this.lastActivityTime
      
      console.log(`距离上次活动: ${Math.round(timeSinceLastActivity / 1000)}秒`)
      
      if (timeSinceLastActivity >= this.autoLogoutTime && this.isLoggedIn) {
        console.log("用户长时间无操作，执行自动登出")
        
        // 显示提示信息（可选）
        if (confirm('由于长时间无操作，系统将自动登出。是否继续留在当前页面？')) {
          // 用户选择继续，重置定时器
          this.resetInactivityTimer()
        } else {
          // 用户选择登出或超时
          this.handleLogout()
        }
      } else {
        // 重新检查
        this.startInactivityCheck()
      }
    },
    
    // 开始不活动检查
    startInactivityCheck() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer)
      }
      
      if (this.isLoggedIn) {
        this.inactivityTimer = setTimeout(() => {
          this.checkInactivity()
        }, this.autoLogoutTime)
      }
    },
    
    // 清理所有定时器
    clearTimers() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer)
        this.inactivityTimer = null
      }
      
      if (this.logoutTimer) {
        clearTimeout(this.logoutTimer)
        this.logoutTimer = null
      }
    },
    
    // 处理图片错误
    handleImageError(e) {
      if (!e || !e.target) return
      e.target.src = this.defaultArticleImage
      e.target.classList.add("img-error")
    },
    
    // 图片安全处理
    safeImageUrl(url, opts = {}) {
      if (!url || typeof url !== "string") return this.defaultArticleImage
      let u = url.trim()

      const preferHttps = opts.preferHttps !== undefined
        ? !!opts.preferHttps
        : typeof window !== "undefined" && window.location && window.location.protocol === "https:"

      const allowHttpDomains = Array.isArray(opts.allowHttpDomains)
        ? opts.allowHttpDomains
        : this.allowHttpDomains || []

      if (u.startsWith("//")) {
        u = (preferHttps ? "https:" : "http:") + u
      }

      if (/^https?:\/\//i.test(u)) {
        try {
          const parsed = new URL(u)
          const isHttp = parsed.protocol === "http:"
          const isAllowedHttp = allowHttpDomains.includes(parsed.hostname)

          if (isHttp && preferHttps && !isAllowedHttp) {
            parsed.protocol = "https:"
            u = parsed.toString()
          }
        } catch (e) {
          return this.defaultArticleImage
        }
      } else {
        return this.defaultArticleImage
      }

      return u
    },
    
    onLogoError(e) {
      if (!e || !e.target) return
      e.target.src = this.defaultArticleImage
      e.target.classList.add("img-error")
    },
    
    onQrImgError(e) {
      if (!e || !e.target) return
      e.target.src = this.defaultArticleImage
      e.target.classList.add("img-error")
    }
  }
}
</script>

<style>
/* 重置样式 */
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
ol,
li,
dl,
dt,
dd,
input {
  margin: 0;
  padding: 0;
}

/* 内减模式 */
* {
  box-sizing: border-box;
}

/* 设置网页统一的字体大小、行高、字体系列相关属性 */
body {
  font: 16px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  color: #333;
  background-image: url("./components/images/20240614210322487-网站背景-1.webp");
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-size: 100%;
}

/* 去除列表默认样式 */
ul,
ol {
  list-style: none;
}

td {
  height: 40px;
}

/* 去除a标签默认下划线，并设置默认文字颜色 */
a {
  text-decoration: none;
  color: #333;
}

/* 设置img的垂直对齐方式为居中对齐，去除img默认下间隙 */
img {
  vertical-align: middle;
}

/* 去除input默认样式 */
input {
  border: none;
  outline: none;
  color: #333;
}

/* 布局工具类 */
.fl {
  float: left;
}

.fr {
  float: right;
}

/* 双伪元素清除法 */
.clearfix::before,
.clearfix::after {
  content: "";
  display: table;
}

.clearfix::after {
  clear: both;
}

/* 头部样式 */
.header {
  margin-bottom: 20px;
}

.navbar {
  border-bottom: 2px solid #eee;
  background: #fff;
}

.navbar-nav .nav-link {
  font-weight: 700;
  color: #333;
  text-align: center;
}

.navbar-nav .nav-link:hover,
.navbar-nav .nav-link:focus,
.navbar-nav li.active {
  color: #540cfa;
}

/* 主要内容区域 */
.con_banner {
  height: 420px;
}

.relative {
  position: relative;
}

.img {
  width: 100%;
  margin: 10px 0;
}

.text {
  margin-top: 20px;
  padding: 15px;
  border-radius: 6px;
  box-shadow: 0px 0px 13px #b9b9b99c;
  letter-spacing: 2px;
  line-height: 27px;
}

.text:hover,
.xiaoxi:hover {
  top: -5px;
  box-shadow: 0px 0px 13px skyblue;
}

.text-zise {
  font-size: 1.25rem;
  color: #d03aff;
}

.back-lvse {
  background-color: #84f783;
}

.back-red {
  font-size: 1.1rem;
  background-color: red;
}

.text_1 {
  font-size: 1.1rem;
  color: #dfc976;
  font-weight: 700;
  margin: 0 5px;
}

.text-red {
  color: red;
}

.back-zise {
  background-color: #d03aff;
}

.left {
  width: 65%;
  margin-right: 3%;
  float: left;
}

.right {
  width: 32%;
  float: left;
}

.xiaoxi {
  width: 100%;
  height: 380px;
  margin-top: 20px;
  box-shadow: 0px 0px 5px #b9b9b99c;
}

.zb {
  background-color: white;
  border-bottom: 1px solid #ebebeb;
  height: 60px;
}

.zb_img {
  float: left;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.zb_text {
  font-size: 1.5rem;
  height: 40px;
  line-height: 40px;
  color: #ff1111;
  font-weight: 700;
}

.right_2,
.right_3,
.ewm,
.left_2 {
  width: 100%;
  margin-top: 20px;
  box-shadow: 0px 0px 5px #b9b9b99c;
  padding: 10px;
  color: #62b6f3;
}

.ewm {
  height: 270px;
}

.icon {
  width: 100%;
  height: 60px;
  background: url("./components/images/主页.png") no-repeat center;
  background-size: contain;
  border-bottom: 1px solid #ebebeb;
}

.nameIcon {
  width: 30px;
  height: 30px;
  margin: 10px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.nameIcon_1 {
  background-image: url("./components/images/常见问题.png");
}

.nameIcon_2 {
  background-image: url("./components/images/hf_2.png");
}

.nameIcon_3 {
  background-image: url("./components/images/wx_ewm.png");
}

.nameIcon_4 {
  background-image: url("./components/images/qq_ewm.png");
}

.name {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #ebebeb;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 50px;
}

.name div,
.ewm div {
  float: left;
}

.ewm_1 {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 1.2rem;
  font-weight: 700;
}

.ewm_1 > div {
  width: 50%;
  height: 50px;
  margin: 0 25%;
}

.ewm_2 {
  width: 100%;
  height: 180px;
}

.ewm_2 .qq,
.ewm_2 .wx,
.ewm_2 .gzh_1,
.ewm_2 .gzh_2 {
  width: 70%;
  height: 100%;
  margin: 10px 15%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.qq {
  background: url("./components/images/qq_ewm.png");
}

.wx {
  background: url("./components/images/wx_ewm.png");
}

.gzh_1 {
  background: url("./components/images/lhb_ewm.png");
}

.gzh_2 {
  background: url("./components/images/mrjp_ewm.png");
}

/* 问答样式 */
.question,
.question-top,
.answer {
  border-left: solid 2px #ff99a6;
  border-right: solid 2px #ff99a6;
  border-bottom: 1px solid #ebebeb;
}

.question-top {
  height: 50px;
  line-height: 50px;
  color: #e24559;
  font-size: 20px;
  font-weight: bolder;
  letter-spacing: 2px;
  text-align: center;
}

.question {
  line-height: 50px;
  color: blueviolet;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 2px;
  text-align: left;
  padding-left: 10px;
}

.answer {
  line-height: 40px;
  color: #181818;
  font-size: 17px;
  letter-spacing: 2px;
  text-align: left;
  padding-left: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 5px 0;
}

/* 底部导航 */
.flex {
  display: none;
}

.index {
  width: 50%;
  height: 100%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.index a {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  height: 100%;
}

.icon_1 {
  width: 20px;
  height: 20px;
  margin: 5px 0;
  background-image: url("./components/images/主页.png");
}

.icon_2 {
  width: 20px;
  height: 20px;
  margin: 5px 0;
  background-image: url("./components/images/常见问题.png");
}

.hf {
  width: 100%;
  height: 70px;
  background-image: url("./components/images/hf_2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

/* 页脚样式 */
.footer {
  width: 100%;
  float: left;
  margin-top: 20px;
  position: static;
  bottom: auto;
  background-color: #fff;
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.06);
}

.footer-div-top img {
  width: 60%;
}

.footer-div {
  width: 25%;
  display: flex;
  flex-wrap: wrap;
}

.footer-divs {
  margin: 0 auto;
  padding: 30px 0;
  display: flex;
  align-items: center;
}

/* 新增：备案号样式 */
.footer-div-icp {
  font-size: 12px;
  color: #666;
  width: 100%;
  margin-bottom: 8px;
}

.footer-div-footer {
  font-size: 11px;
  color: #999;
  width: 100%;
}

.footer-div-top-btn {
  float: left;
  background-image: -webkit-linear-gradient(0deg, #3ca5f6 0%, #a86af9 100%);
  padding: 4px 9px 4px 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  font-size: 11px;
  margin-right: 5px;
}

.footer-div-top-btn a {
  color: #fff;
}

.footer-div-top-btn:nth-child(2) {
  background-color: #e76dcb;
  background-image: none;
}

.footer-div-top-btn:nth-child(3) {
  background-color: #f55066;
  background-image: none;
}

.footer-div-top {
  width: 100%;
}

.footer-div:nth-child(2) {
  width: 50%;
  margin: 0 50px;
  display: flex;
  flex-direction: column;
}

.footer-div:nth-child(2) .footer-div-footer {
  margin-top: 0;
}

.footer-div-btn {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.footer-div-btn a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: rgba(50, 50, 50, 0.06);
  border-radius: 50%;
  margin: 0 5px;
}

.btn-icon {
  width: 20px;
  height: 20px;
}

.footer-div:nth-child(3) {
  width: 230px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.footer_ewm {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.a-img {
  position: relative;
}

.footer-div-btn a:nth-child(1):hover .img-ab {
  display: flex;
}

.img-ab {
  width: 90px;
  height: 90px;
  overflow: hidden;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background-color: #fff;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -100px;
  display: none;
}

.img-ab img {
  width: 80px;
  height: 80px;
}

.footer_ewm img {
  width: 90px;
  height: 90px;
}

.footer_ewm > div {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 11px;
  color: #999;
}

.footer_none {
  display: none;
}

/* Swiper 轮播图样式 */
.swiper {
  width: 100%;
  height: 320px;
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}

.slide-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-size: cover;
  background-position: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  color: #fff;
}

.swiper-pagination {
  text-align: right;
}

.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: var(--swiper-pagination-bottom, 8px);
  top: var(--swiper-pagination-top, auto);
  left: 0;
  width: 98%;
}

.swiper-button-next,
.swiper-button-prev {
  color: var(--swiper-navigation-color, #e2e7ed);
}

.con_banner {
  height: 605px;
}

.ewmContent {
  display: none;
  width: 100%;
  height: 600px;
}

.ewmContent > div {
  width: 100%;
}

.ewmContent > div .ewm_1 > div {
  width: 60%;
  height: 50px;
  margin: 0 20%;
}

:root {
  --primary: #2ac7ff;
  --primary-2: #5e9cff;
  --text-muted: #6b7280;
  --card-border: #e9eef5;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
@media (min-width: 1400px) {
  .news-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 992px) {
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

.news-link {
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;
}
.news-link:hover {
  text-decoration: none;
  color: inherit;
}

.news-card {
  position: relative;
  border: 1px solid var(--card-border);
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(20, 23, 45, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  display: flex;
  flex-direction: column;
}
.news-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(20, 23, 45, 0.12);
}

.card-media {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
}
.card-media::before {
  content: "";
  display: block;
  padding-top: 56.25%;
}
.card-media::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.06) 100%
  );
  pointer-events: none;
}
.card-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.img-error {
  filter: grayscale(100%);
}
.badge {
  position: absolute;
  left: 12px;
  top: 12px;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--primary), var(--primary-2));
  color: #fff;
  box-shadow: 0 4px 10px rgba(42, 199, 255, 0.4);
}

.card-content {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
  background: #fff;
}
.card-title {
  font-size: 0.98rem;
  line-height: 1.5;
  color: #1f2937;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: calc(1.5em * 2);
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-muted);
  font-size: 12px;
  margin-top: auto;
}
.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.icon-calendar::before {
  content: "📅";
}
.icon-eye::before {
  content: "👁️";
}
.icon-like::before {
  content: "👍";
}

/* 换页器 */
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  flex-wrap: wrap;
}
.pager-info {
  color: #666;
  font-size: 13px;
  margin-right: 8px;
}
.pager-info b {
  color: #ff6a00;
  font-weight: 600;
}
.pager-btn {
  padding: 6px 12px;
  border: 1px solid #e9eef5;
  background: #fff;
  color: #333;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 36px;
  text-align: center;
}
.pager-btn:hover:not(:disabled) {
  border-color: #ffc799;
  background: #fff7f0;
}
.pager-btn.active {
  background: #ff6a00;
  color: #fff;
  border-color: #ff6a00;
}
.pager-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.pager-ellipsis {
  padding: 6px 8px;
  color: #999;
  font-size: 13px;
}

/* 响应式设计 */
/* 统一约束 Logo 尺寸，避免撑开布局 */
.logo-box {
  width: 300px;
  height: 150px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.logo-box .Logo {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

/* 如果需要进一步限制导航栏高度，保持一致的对齐 */
.header .navbar-brand {
  display: inline-flex;
  align-items: center;
  height: 56px;
}

/* 用户操作区域样式 */
.user-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn.login,
.btn.register {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn.login {
  background: transparent;
  border: 1px solid #540cfa;
  color: #540cfa;
}

.btn.login:hover {
  background: #540cfa;
  color: white;
}

.btn.register {
  background: #540cfa;
  border: 1px solid #540cfa;
  color: white;
}

.btn.register:hover {
  background: #3d00e0;
  border-color: #3d00e0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.btn.logout {
  padding: 4px 12px;
  border: 1px solid #dcdfe6;
  background: white;
  color: #666;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn.logout:hover {
  border-color: #ff4d4f;
  color: #ff4d4f;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .user-actions {
    position: static;
    top: auto;
    right: auto;
    margin-top: 15px;
    justify-content: center;
    width: 100%;
  }

  .user-info {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
    justify-content: center;
  }
  
  .btn.login,
  .btn.register {
    flex: 1;
    max-width: 120px;
    text-align: center;
  }
}

/* 移动端导航栏样式优化 */
@media screen and (max-width: 991px) {
  /* 移动端汉堡菜单样式 */
  .navbar-toggler {
    display: block;
    position: absolute;
    right: 15px;
    top: 20px;
    border: none;
    background: none;
  }
  
  /* 隐藏PC端导航项 */
  .navbar-nav {
    display: none;
  }
  
  /* 移动端菜单展开时的样式 */
  .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 1000;
    max-height: 100vh;
    overflow-y: auto;
    padding: 80px 20px 20px;
    display: none;
  }
  
  .navbar-collapse.show {
    display: block;
  }
  
  /* 移动端导航项样式 */
  .navbar-collapse .navbar-nav {
    display: block;
    margin-bottom: 30px;
  }
  
  .navbar-collapse .nav-item {
    margin-bottom: 15px;
  }
  
  .navbar-collapse .nav-link a {
    display: block;
    padding: 12px 0;
    font-size: 18px;
    border-bottom: 1px solid #eee;
  }
  
  /* 移动端用户操作区域 */
  .navbar-collapse .user-actions {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .navbar-collapse .btn.login,
  .navbar-collapse .btn.register {
    width: 100%;
    max-width: none;
    padding: 12px;
    font-size: 16px;
  }
  
  .navbar-collapse .user-info {
    flex-direction: column;
    gap: 15px;
  }
  
  .navbar-collapse .user-name {
    font-size: 16px;
    text-align: center;
  }
  
  .navbar-collapse .btn.logout {
    width: 100%;
    padding: 12px;
    font-size: 16px;
  }
}

@media screen and (max-width: 980px) {
  .con_banner {
    height: 40vw !important;
  }

  .header {
    margin-bottom: 15px;
  }

  .container .left {
    width: 100%;
  }

  .right {
    display: none;
  }

  .navbar {
    padding: 0.5rem 1rem;
  }

  .hf {
    display: none;
  }

  /* 统一约束 Logo 尺寸，避免撑开布局 */
  .logo-box {
    width: 200px;
    height: 100px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .logo-box .Logo {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
  }

  /* 如果需要进一步限制导航栏高度，保持一致的对齐 */
  .header .navbar-brand {
    display: inline-flex;
    align-items: center;
    height: 56px;
  }

  body .main {
    padding-top: 20px;
  }

  .footer {
    padding-bottom: 50px;
  }
}

@media screen and (max-width: 1350px) {
  .name {
    font-size: 14px;
  }

  .question {
    line-height: 30px;
    font-size: 14px;
  }

  .left {
    width: 70%;
    margin-right: 1%;
    float: left;
  }

  .right {
    width: 29%;
    float: left;
  }
}

@media screen and (max-width: 1500px) {
  .footer-divs {
    width: 1350px;
  }
}

@media screen and (max-width: 1370px) {
  .footer-divs {
    width: 1100px;
  }
}

@media screen and (max-width: 1130px) {
  .name div {
    font-size: 13px;
  }

  .footer-divs {
    width: 90%;
  }
}

@media screen and (max-width: 1000px) {
  .name div {
    font-size: 12px;
  }
}

@media screen and (max-width: 992px) {
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 780px) {
  body {
    background-image: url("./components/images/20240614210322487-网站背景-1.webp");
  }

  .footer-div:nth-child(1) {
    display: none;
  }

  .footer-divs .footer-div:nth-child(2) {
    margin-left: 0;
    width: 100%;
  }

  .footer-divs {
    justify-content: space-between;
  }

  .footer-div-top-btn {
    margin-bottom: 5px;
  }

  .swiper-container {
    border-radius: 10px;
  }

  .text {
    border-radius: 10px;
  }

  .footer_none {
    display: flex;
  }
  
  /* 移动端备案号调整 */
  .footer-div-icp {
    font-size: 11px;
    margin-bottom: 5px;
  }
  
  .footer-div-footer {
    font-size: 10px;
  }
}

.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1 0 auto;
}

.footer {
  flex-shrink: 0;
}

/* 移动端导航栏 - 只在首页和信息页显示 */
.flex.mobile-nav {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #fff;
  border-top: 1px solid #ebebeb;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

/* 移动端导航激活状态 */
.mobile-nav .index.active {
  background-color: #f5f5f5;
}

.mobile-nav .index.active .nameIcon {
  opacity: 1;
}

.mobile-nav .index.active div {
  color: #540cfa;
}

@media screen and (max-width: 768px) {
  .news-grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .flex.mobile-nav {
    display: flex;
  }
  
  .mobile-nav-hidden .flex.mobile-nav {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .footer .footer-divs {
    flex-wrap: wrap;
    justify-content: center;
    padding: 20px 0;
  }

  .footer-divs .footer-div:nth-child(2) {
    width: 100%;
    margin: 0;
  }

  .footer-divs .footer-div:nth-child(2) > div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .footer-divs .footer-div:nth-child(3) {
    margin-top: 10px;
    width: 100%;
    justify-content: center;
  }
  
  /* 移动端备案号调整 */
  .footer-div-icp {
    font-size: 10px;
    margin-bottom: 5px;
  }
  
  .footer-div-footer {
    font-size: 10px;
  }
  
  /* 移动端二维码调整 */
  .footer_ewm img {
    width: 80px;
    height: 80px;
  }
}

/* 主内容区域 */
.main-content {
  min-height: calc(75vh - 180px);
}

/* 信息页面容器 */
.info-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 16px;
}

/* 移动端导航隐藏 */
.mobile-nav-hidden .flex.mobile-nav {
  display: none;
}

/* 移动端表单优化 */
@media screen and (max-width: 768px) {
  .login-page, .register-page {
    padding: 20px 15px;
    min-height: calc(100vh - 140px);
  }
  
  .login-card, .register-card {
    padding: 25px 20px;
    max-width: 100%;
    margin: 0;
    border-radius: 12px;
  }
  
  /* 输入框优化，防止iOS缩放 */
  input[type="tel"],
  input[type="text"],
  input[type="password"] {
    font-size: 16px !important;
    height: 44px;
  }
  
  /* 按钮优化 */
  .submit-btn, .code-btn {
    height: 44px;
    font-size: 16px;
  }
  
  /* 表单标签优化 */
  .form-group label {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  /* 标题优化 */
  .login-title, .register-title {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .login-subtitle, .register-subtitle {
    font-size: 14px;
    margin-bottom: 25px;
  }
  
  /* 表单间距优化 */
  .login-form, .register-form {
    gap: 18px;
  }
  
  /* 导航栏优化 */
  .navbar-brand {
    max-width: 200px;
  }
  
  .logo-box {
    width: 200px;
    height: 100px;
  }
  
  .flex.mobile-nav {
    display: flex;
  }
  
  .mobile-nav-hidden .main-content {
    padding-bottom: 60px;
  }
}

@media screen and (max-width: 576px) {
  .login-card, .register-card {
    padding: 20px 15px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
  
  .login-title, .register-title {
    font-size: 22px;
  }
  
  /* 验证码输入区域优化 */
  .input-with-code {
    flex-direction: column;
    gap: 10px;
  }
  
  .code-btn {
    width: 100%;
    padding: 12px;
  }
  
  /* 协议区域优化 */
  .agreement {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  /* Toast提示优化 */
  .toast {
    top: 70px;
    left: 15px;
    right: 15px;
    font-size: 13px;
    padding: 10px 15px;
  }
}
</style>